import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import type { MappedCountry, RegistrationNumbersConstraintsTypes } from '@/shared/models/countryModels'
import type { Locales } from '@/shared/utils/cookiesUtils'
import { listCountries } from '@/shared/services/countryServices'

export const countryQueryKeys = {
    countries: ['countries']
}

export const useCountries = (
    locale: Locales | undefined,
    registrationNumbersConstraintsType?: RegistrationNumbersConstraintsTypes
): UseQueryResult<MappedCountry[]> => {
    return useQuery({
        queryKey: countryQueryKeys.countries,
        queryFn: () => listCountries(locale, registrationNumbersConstraintsType)
    })
}
